import useMemberSession from "@/hooks/useMemberSession";

const MEMBER_MAILTO =
    "mailto:hello@wearetheweave.co.uk" +
    "?subject=" +
    encodeURIComponent("1% Club — Looking for a new tool") +
    "&body=" +
    encodeURIComponent("Hi Weave,\n\nI'm looking for a tool that does:\n\n");

export default function Footer() {
    const { isMember } = useMemberSession();

    return (
        <footer
            className="border-t border-weave-border bg-weave-bg mt-24"
            data-testid="site-footer"
        >
            {isMember && (
                <div
                    className="border-b border-weave-border bg-weave-surface-alt"
                    data-testid="footer-member-feedback"
                >
                    <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 grid md:grid-cols-12 gap-6 items-end">
                        <div className="md:col-span-8">
                            <p className="editorial-label text-weave-teal mb-2">
                                Looking for something new?
                            </p>
                            <h3 className="text-2xl md:text-3xl font-light tracking-tight text-weave-ink leading-snug">
                                Tell us what you're searching for — maybe
                                we'll have an answer soon.
                            </h3>
                        </div>
                        <div className="md:col-span-4 md:text-right">
                            <a
                                href={MEMBER_MAILTO}
                                className="btn-secondary"
                                data-testid="footer-tell-us"
                            >
                                Tell us →
                            </a>
                        </div>
                    </div>
                </div>
            )}

            <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <div className="editorial-label text-weave-slate">
                    The Weave · Opportunity Unlock · Experience, rewoven
                </div>
                <div className="text-sm text-weave-slate flex flex-wrap items-center gap-x-6 gap-y-2">
                    <span className="text-weave-ink">
                        Second acts welcomed. Founders too.
                    </span>
                    {!isMember && (
                        <a
                            className="weave-link"
                            href="https://awake.wearetheweave.co.uk/join"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-club-join"
                        >
                            Join the 1% Club
                        </a>
                    )}
                </div>
            </div>
        </footer>
    );
}
